import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SvgIconModule } from '@commons/svg-icon/svg-icon.module';
import { I18nFieldModule } from '@domains/company/i18n-field/i18n-field.module';
import { InitialsComponent } from '@domains/directory/initials/initials.component';
import { ListLetterPageComponent } from '@domains/directory/list-letter-page/list-letter-page.component';

@NgModule({
  imports: [CommonModule, SvgIconModule, I18nFieldModule, RouterModule],
  declarations: [InitialsComponent, ListLetterPageComponent],
  exports: [InitialsComponent, ListLetterPageComponent],
})
export class DirectoryModule {}
